import { UploadCityBillResponse } from './types';
import axiosLib from 'axios';
import axios from 'utils/my-axios';
const DEFAULT_API_BASE = '';

export async function uploadCityBillPdf(
  file: File,
  propertyId: number,
  buildingIds: number[],
  options: {
    apiBaseUrl?: string;
    onProgress?: (percent: number) => void;
    signal?: AbortSignal;
  } = {},
  companyId?: number
): Promise<UploadCityBillResponse> {
  const base = options.apiBaseUrl ?? DEFAULT_API_BASE;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('property_id', String(propertyId));
  if (companyId) {
    formData.append('company_id', String(companyId));
  }
  formData.append('building_ids', JSON.stringify(buildingIds));

  const { data } = await axios.post<UploadCityBillResponse>(`${base}/savings/city-bills/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    signal: options.signal,
    onUploadProgress: (event: ProgressEvent) => {
      if (!event.total) return;
      const percent = Math.round((event.loaded * 100) / event.total);
      options.onProgress?.(percent);
    }
  });

  return data;
}

export function getUploadErrorMessage(error: unknown): string {
  if (axiosLib.isAxiosError(error)) {
    const data = error.response?.data as { message?: string | string[] } | undefined;
    if (data?.message) {
      return Array.isArray(data.message) ? data.message.join(', ') : data.message;
    }
    if (error.response?.status === 413) {
      return 'File exceeds maximum size of 3 MB';
    }
    return error.message || 'Upload failed';
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Upload failed';
}
